var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonofroogPinkOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_118)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.219 488.299C453.478 575.952 538.125 607.43 536.139 695.219C531.321 908.201 -8.901 695.219 -8.901 695.219C-8.901 695.219 -19.2837 -79.4503 172.673 80.8374C220.988 121.182 217.771 117.604 279.744 128.504C349.847 140.835 335.987 88.3839 407.126 90.7211C484.455 93.2616 515.954 166.452 536.139 241.208C562.839 340.092 442.085 386.052 448.219 488.299Z",
    fill: "#EEEEEE",
    stroke: "#FF007A",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.338 333.394C314.338 390.187 348.267 436.227 390.12 436.227C431.973 436.227 465.902 390.187 465.902 333.394C465.902 276.601 431.973 293.868 390.12 293.868C348.267 293.868 314.338 276.601 314.338 333.394Z",
    fill: "#C4C4C4",
    stroke: "#FF007A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2051 311.72C75.2051 380.559 100.008 432.858 151.162 432.858C202.316 432.858 260.45 380.559 260.45 311.72C260.45 242.88 246.224 230.773 195.07 230.773C143.916 230.773 75.2051 242.88 75.2051 311.72Z",
    fill: "#C4C4C4",
    stroke: "#FF007A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 47.1534,
    transform: "matrix(-1 0 0 1 388.433 368.865)",
    fill: "black",
    stroke: "#FF007A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    r: 47.1534,
    transform: "matrix(-1 0 0 1 156.04 348.656)",
    fill: "black",
    stroke: "#FF007A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.902 401.291C373.004 408.346 385.292 407.497 392.347 399.394C399.401 391.291 385.778 393.675 377.676 386.62C369.573 379.565 370.059 365.743 363.005 373.846C355.95 381.949 356.799 394.236 364.902 401.291Z",
    fill: "white",
    stroke: "#FF007A",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.46 376.881C132.46 387.336 141.507 395.811 152.668 395.811C163.829 395.811 172.877 387.336 172.877 376.881C172.877 366.426 163.829 376.881 152.668 376.881C141.507 376.881 132.46 366.426 132.46 376.881Z",
    fill: "white",
    stroke: "#FF007A",
    strokeWidth: 4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonofroogPinkOutline);
export default __webpack_public_path__ + "static/media/monofroog-pink-outline.0fff4f0cd7f2df34713af033dadeab54.svg";
export { ForwardRef as ReactComponent };